<svelte:options accessors />

<script context="module" lang="ts">
	export let count = 0;
	interface IAddress {
		_str: string;
		needNumber: boolean;
		street: any;
		city: any;
		state: any;
		zipcode: any;
		entries: any;
	}
	function buildAddress(suggestion: any): IAddress {
		let streetStr = suggestion.street_line;
		let streetStr2 = suggestion.street_line;
		let _needNumber = false;
		if (suggestion.secondary) {
			streetStr2 += ' ' + suggestion.secondary + ' ';
			if (suggestion.entries > 1) {
				_needNumber = true;
				suggestion.secondary += ' (' + suggestion.entries + ' entries)';
			}
			streetStr += ' ' + suggestion.secondary;
		}
		let data: IAddress = {
			_str: streetStr + ' ' + suggestion.city + ', ' + suggestion.state + ' ' + suggestion.zipcode,
			needNumber: _needNumber,
			street: streetStr2,
			city: suggestion.city,
			state: suggestion.state,
			zipcode: suggestion.zipcode,
			entries: suggestion.entries
		};
		return data;
	}
</script>

<script lang="ts">
	export const InstanceID = count;
	count += 1;
	import FormGroup from '../sub_components/FormGroup.svelte';
	import { showLoadingBackdrop } from '$lib/client/store';
	import { Event } from '$lib/event';
	import { onMount } from 'svelte';
	import type { AddressConfig } from '$lib/config';
	import * as Store from '$lib/client/store';
	import { REST } from '$lib/client/conn';
	import { KTIForm, ServerDataValidation } from '../form';
	export let Valid: boolean = false;
	export let Config: AddressConfig;
	let StreetEl: HTMLInputElement;
	let StreetLabelEl: HTMLElement;
	let CityEl: HTMLInputElement;
	let StateEl: HTMLInputElement;
	let PostCodeEl: HTMLInputElement;
	let ErrorEl: HTMLElement;
	let AutoCompleteEl: HTMLElement | null;
	let autocompleteObj: any;
	let suggestions: IAddress[] = [];
	//let sug_strs: string[] = [];
	let inputVal: string = '';
	let useOtherAddress = false;
	let POPrefixes = ['post o', 'po ', 'p.o'];
	let lookupComplete = false;
	let addressCheckRunning = false;
	let addressCheckComplete = false;

	const requiresCheck =
		Config.UseForParticipationCheck ||
		Config.UseForProductCheck ||
		Config.UseForSubmissionDupCheck ||
		Config.UseForInstanceCheck;
	let serverValidation: ServerDataValidation | null = requiresCheck
		? KTIForm.addServerValidation('address', Config.id)
		: null;

	const addressFilter = async (query: string) => {
		lookupComplete = false;
		const response = await fetch(
			`https://us-autocomplete-pro.api.smartystreets.com/lookup?key=8565694694387037&search=` +
				escape(query)
		);
		if (response.status != 200) {
			return [];
		}
		const data = await response.json();
		suggestions = new Array();
		//sug_strs = new Array();
		for (let i = 0; i < data.suggestions.length; i++) {
			//Remove PO boxes if not allowed
			if (
				!Config.AllowPOBox &&
				POPrefixes.some((v) => data.suggestions[i].street_line.toLowerCase().startsWith(v))
			) {
				continue;
			}
			suggestions.push(buildAddress(data.suggestions[i]));
		}
		// if (suggestions.length == 0) {
		// } else {
		// 	for (let i = 0; i < suggestions.length; i++) {
		// 		//sug_strs.push(suggestions[i]._str);
		// 		sug_strs.push(suggestions[i].street);
		// 	}
		// }
		lookupComplete = true;
		return suggestions; //.map((s) => s._str);
	};
	let mdb: any;
	function createAutocomplete() {
		autocompleteObj = new mdb.Autocomplete(AutoCompleteEl, {
			filter: addressFilter, //What to display in the textbox after selecting value from itemContent()
			threshold: 3, //Don't start searching until this number of characters have been entered
			debounce: 300, //Delay between requests, prevent spam when typing or entering text quickly
			autoSelect: true, //Why isn't this working?!
			itemContent: (suggestion: any) => {
				//What to show
				//get the ._str from the suggestions array
				//let i = sug_strs.indexOf(street);
				//return suggestions[i]._str;
				console.log(suggestion);
				return suggestion._str;
			}
			//displayValue: (value) => value.name
		});
	}
	let last_suggestion: IAddress = {
		_str: '',
		street: '',
		city: '',
		state: '',
		zipcode: ''
	};
	function setAddress(suggestion: IAddress) {
		last_suggestion = suggestion;
		StreetEl.value = suggestion.street;
		CityEl.value = suggestion.city;
		StateEl.value = suggestion.state;
		PostCodeEl.value = suggestion.zipcode;
		activeClass = true;
		setValid();
	}
	onMount(async () => {
		if (serverValidation) {
			serverValidation.valid = false;
		}
		if (!Config.Title) {
			Config.Title = 'Address:';
		}
		mdb = await import('mdb-ui-kit');
		const { Input } = await import('mdb-ui-kit');
		//AutoCompleteEl = document.getElementById(`Street_Outline_${InstanceID}`);
		if (!AutoCompleteEl) {
			console.log('AutoCompleteEl is null');
			return;
		}
		new Input(AutoCompleteEl).init();
		createAutocomplete();
		AutoCompleteEl.addEventListener('open.mdb.autocomplete', (e) => {
			console.log('opened');
			if (!Config.AllowPOBox && POPrefixes.some((v) => inputVal.toLowerCase().startsWith(v))) {
				console.log('closing');
				setTimeout(() => {
					autocompleteObj.close();
					autocompleteObj.dispose();
					createAutocomplete();
				}, 1);
			}
			//console.log('open:', e);
			//console.log('Autocomplete opened');
			//console.log('Suggestions:', suggestions);
			let hasMatch = suggestions.some((s) => s.street == StreetEl.value);
			if (hasMatch && suggestions.length == 1) {
				console.log('one suggestion and match');
				setAddress(suggestions[0]);
				setTimeout(() => {
					autocompleteObj.close();
					autocompleteObj.dispose();
					createAutocomplete();
				}, 1);
			}
		});
		AutoCompleteEl.addEventListener('itemSelect.mdb.autocomplete', (e: any) => {
			console.log('itemSelect:', e);
			//console.log('value:', e.value);
			setAddress(e.value as IAddress);
			checkAddress();
		});
		AutoCompleteEl.addEventListener('close.mdb.autocomplete', (e) => {
			console.log('close:', e);
			console.log('streetvalue', StreetEl.value);
			if (StreetEl.value === '[object Object]') {
				StreetEl.value = last_suggestion.street;
			}
			//StreetEl.value = suggestion.street;
			//console.log('e', e);
			// let listBoxIndex = sug_strs.indexOf(StreetEl.value);
			// //let sugg = suggestions.find((s) => s._str == e.returnValue);
			// //console.log('sug_strs', sug_strs);
			// //console.log('suggestions', suggestions);
			// if (listBoxIndex == -1) {
			// 	//not found
			// 	return;
			// }
			// let sugg = suggestions[listBoxIndex]; //lookup suggestion based on string selected
			// StreetEl.value = sugg.street;
			// CityEl.value = sugg.city;
			// StateEl.value = sugg.state;
			// PostCodeEl.value = sugg.zipcode;
			//addressClick(sugg);
		});
		StreetEl.addEventListener('blur', (e) => {
			setTimeout(validate, 50);
		});

		Store.formData.subscribe((data) => {
			if (useOtherAddress) {
				if (data?.shipping_street) {
					StreetEl.value = data.shipping_street;
					CityEl.value = data.shipping_city;
					StateEl.value = data.shipping_state;
					PostCodeEl.value = data.shipping_zipcode;
				}
			}
		});
	});
	$: if (useOtherAddress) {
		let formData = Store.formData.get();
		if (formData?.shipping_street) {
			StreetEl.value = formData.shipping_street;
			CityEl.value = formData.shipping_city;
			StateEl.value = formData.shipping_state;
			PostCodeEl.value = formData.shipping_zipcode;
		}
	}
	export async function checkAddress() {
		Valid = false;
		if (
			StreetEl.value == '' ||
			CityEl.value == '' ||
			StateEl.value == '' ||
			PostCodeEl.value == ''
		) {
			setInvalid();
			return;
		}
		let get_url =
			`https://us-street.api.smartystreets.com/street-address?key=8565694694387037&street=` +
			StreetEl.value +
			'&city=' +
			CityEl.value +
			'&state=' +
			StateEl.value +
			'&zipcode=' +
			PostCodeEl.value;
		const response = await fetch(get_url).catch((e) => {
			console.log(e);
		});
		if (!response || response.status != 200) {
			setInvalid();
			console.log('Bad response from Smarty');
			return;
		}
		const data = await response.json().catch((e) => {
			console.log(e);
		});
		if (data && data.length != 0) {
			//split into 2 character sections
			//console.log(data[0].analysis.footnotes)
			let analysisInfo = new Array();
			for (let i = 0; i + 2 <= data[0].analysis.dpv_footnotes.length; i += 2) {
				analysisInfo.push(data[0].analysis.dpv_footnotes.substring(i, i + 2));
			}
			//console.log(analysisInfo);
			if (analysisInfo.includes('N1')) {
				return setInvalid('Please enter a unit number.');
				//$("#street").focus();
			} else if (analysisInfo.includes('CC')) {
				return setInvalid('Please enter valid unit number.');
				//$("#street").focus();
			} else if (analysisInfo.includes('BB') || analysisInfo.includes('AA')) {
				let addressData = data[0];
				if (addressData.components.plus4_code) {
					PostCodeEl.value =
						addressData.components.zipcode + '-' + addressData.components.plus4_code;
				}
			}
			console.log('checkAddress - setValid');
			setValid();
			// 	$('#street').val(data[0].delivery_line_1);
			// 	if (compInfo?.Address?.DuplicateAddressMessage) {
			// 		fetch('/mc/dup_check/' + formName, {
			// 			method: 'post',
			// 			headers: { 'Content-Type': 'application/json' },
			// 			body: JSON.stringify({
			// 				street: $('#street').val(),
			// 				city: $('#city').val(),
			// 				state: $('#state').val(),
			// 				zipcode: $('#zipcode').val()
			// 			})
			// 		})
			// 			.then((data) => {
			// 				data.json().then((data) => {
			// 					console.log(data);
			// 					if ('error' in data) {
			// 						setAddressInvalid('Invalid Address');
			// 						showError(compInfo.Address.DuplicateAddressMessage);
			// 					} else {
			// 						setAddressValid();
			// 						//Show valid? - green checkbox? etc...
			// 					}
			// 				});
			// 			})
			// 			.catch((err) => {
			// 				LoadingFSOff();
			// 			});
			// }
		}
	}
	let isInvalid = false;
	let isValid = false;
	let activeClass = false;
	export function setInvalid(errorMsg?: string) {
		if (serverValidation) {
			serverValidation.valid = false;
		}
		Valid = false;
		isInvalid = true;
		isValid = false;
		activeClass = false;
		if (errorMsg) {
			ErrorEl.innerHTML = errorMsg;
			ErrorEl.style.display = 'block';
		} else {
			ErrorEl.style.display = 'none';
		}
		if (StreetEl.value == '') {
			CityEl.value = '';
			PostCodeEl.value = '';
			StateEl.value = '';
		}
	}
	export function setNuetral() {
		Valid = false;
	}
	export function doServerValidation() {
		if (serverValidation) {
			//Zipcode will change when plus 4 is added (don't rerun validation just because of that); only if street and/or state changes
			if (
				(serverValidation.validated || serverValidation.sending) &&
				serverValidation.value &&
				serverValidation.value.street == StreetEl.value &&
				serverValidation.value.city == CityEl.value &&
				serverValidation.value.state == StateEl.value
			) {
				return;
			}
			serverValidation.validate_value({
				street: StreetEl.value,
				state: StateEl.value,
				city: CityEl.value,
				zipcode: PostCodeEl.value
			});
		}
	}
	export function setValid() {
		Valid = true; //Show valid even if address doesn't pass server validation (duplicate, etc...) checks
		isValid = true;
		isInvalid = false;
		ErrorEl.style.display = 'none';
		activeClass = true;

		doServerValidation();
	}
	export function focus() {
		StreetEl.focus();
	}
	export async function validate() {
		await checkAddress();
		console.log('Validating ADDRESS', Config.Required, useOtherAddress, StreetEl.value);
		if (useOtherAddress) {
			Store.formData.mapValueTo('shipping_street', Config.DBCol + 'street');
			Store.formData.mapValueTo('shipping_city', Config.DBCol + 'city');
			Store.formData.mapValueTo('shipping_state', Config.DBCol + 'state');
			Store.formData.mapValueTo('shipping_zipcode', Config.DBCol + 'zipcode');
			setValid();
		} else if (Config.Required) {
			console.log('Suggestions:', suggestions);
			if (StreetEl.value == '') {
				setInvalid('Please enter a street address');
			} else if (!Valid && suggestions.length == 1) {
				setAddress(suggestions[0]);
			}
		}
		console.log('Address.validate() returning', Valid);
		return Valid;
	}
	function getData() {
		return [
			['street', StreetEl.value],
			['city', CityEl.value],
			['state', StateEl.value],
			['zipcode', PostCodeEl.value]
		];
	}
	export function appendData(formData: FormData) {
		for (let [key, value] of getData()) {
			formData.append(Config.DBCol + key, value);
		}
	}
	$: if (Valid) {
		Store.formData.setValues({
			[Config.DBCol + 'street']: StreetEl.value,
			[Config.DBCol + 'city']: CityEl.value,
			[Config.DBCol + 'state']: StateEl.value,
			[Config.DBCol + 'zipcode']: PostCodeEl.value
		});
	}
	function changeit() {
		changing = true;
		setTimeout(() => {
			changing = false;
		}, 500);
	}
	let changing = false;
	let city = '';
	let state = '';
	let zip = '';
</script>

<FormGroup {Config}>
	<div class="col-6" style="margin-bottom: 0px">
		<div class="comp-title">{Config.Title}</div>
	</div>
	{#if Config.UseAnotherAddress != null}
		<div class="col-6" style="margin-bottom: 0px">
			<div class="form-check">
				<input
					class="form-check-input"
					type="checkbox"
					name="differentThanShipping"
					bind:checked={useOtherAddress}
				/>
				<label class="form-check-label" for="differentThanShipping"
					><b>{Config.UseAnotherAddressDesc}</b></label
				>
			</div>
		</div>
	{/if}
	<div class="col-12" style={useOtherAddress ? 'display: none' : ''}>
		<div class="col" class:required={Config.Required}>
			<div
				class="form-outline autocomplete"
				id="Street_Outline_{InstanceID}"
				bind:this={AutoCompleteEl}
			>
				<input
					class="form-control"
					id="street_{InstanceID}"
					type="text"
					name="street_{InstanceID}"
					required={Config.Required && !useOtherAddress}
					disabled={useOtherAddress}
					bind:this={StreetEl}
					class:is-invalid={isInvalid}
					class:is-valid={isValid}
					class:active={activeClass}
					on:input={(e) => {
						inputVal = e.target?.value;
						if (
							!Config.AllowPOBox &&
							POPrefixes.some((v) => inputVal.toLowerCase().startsWith(v))
						) {
							setInvalid('Please enter a valid physical address');
						} else {
							ErrorEl.innerHTML = 'Invalid street address';
						}
						if (serverValidation) {
							serverValidation.valid = false;
						}
						if (!addressCheckRunning) {
							addressCheckComplete = false;
						}
					}}
				/>
				<label
					class="form-label"
					id="streetLbl_{InstanceID}"
					for="street_{InstanceID}"
					bind:this={StreetLabelEl}>Street Address</label
				>
				<div class="invalid-tooltip hidden" id="streetInfo_{InstanceID}" bind:this={ErrorEl} />
				<div class="msg-spacer" />
			</div>
		</div>
	</div>
	<div class="col-10 col-md-7" style={useOtherAddress ? 'display: none' : ''}>
		<div class="col form-outline">
			<input
				class="form-control"
				id="city_{InstanceID}"
				type="text"
				name="city_{InstanceID}"
				bind:this={CityEl}
				class:is-invalid={isInvalid}
				class:is-valid={isValid}
				class:active={activeClass}
				bind:value={city}
				on:input={changeit}
				disabled
			/>
			<label class="form-label" for="city_{InstanceID}">City</label>
			<div class="form-notch">
				<div class="form-notch-leading" style="width: 9px;" />
				<div class="form-notch-middle" style="width: 45.8px;" />
				<div class="form-notch-trailing" />
			</div>
		</div>
	</div>
	<div class="col-2 col-md-2" style={useOtherAddress ? 'display: none' : ''}>
		<div class="col form-outline">
			<input
				class="form-control"
				id="state_{InstanceID}"
				type="text"
				name="state_{InstanceID}"
				bind:this={StateEl}
				class:is-invalid={isInvalid}
				class:is-valid={isValid}
				class:active={activeClass}
				bind:value={state}
				on:input={changeit}
				disabled
			/>
			<label class="form-label" for="state_{InstanceID}">State</label>
			<div class="form-notch">
				<div class="form-notch-leading" style="width: 9px;" />
				<div class="form-notch-middle" style="width: 45.8px;" />
				<div class="form-notch-trailing" />
			</div>
		</div>
	</div>
	<div class="col-md-3 col-sm" style={useOtherAddress ? 'display: none' : ''}>
		<div class="col form-outline">
			<input
				class="form-control"
				id="zipcode_{InstanceID}"
				type="text"
				name="zipcode_{InstanceID}"
				bind:this={PostCodeEl}
				class:is-invalid={isInvalid}
				class:is-valid={isValid}
				class:active={activeClass}
				bind:value={zip}
				on:input={changeit}
				disabled
			/>
			<label class="form-label" for="zipcode_{InstanceID}">Zip Code</label>
			<div class="form-notch">
				<div class="form-notch-leading" style="width: 9px;" />
				<div class="form-notch-middle" style="width: 70.8px;" />
				<div class="form-notch-trailing" />
			</div>
		</div>
	</div>
	{#if useOtherAddress}
		<div class="col-12" style="margin-top: 10px">
			<div class="alert alert-info" role="alert">
				<p>
					{StreetEl.value}<br />
					{CityEl.value}, {StateEl.value}{' '}{PostCodeEl.value}
				</p>
			</div>
		</div>
	{/if}
</FormGroup>
